import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    filterInputContainer: {
        display: "flex",
        justifyContent: "end"
    }
}));